import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../public/assets/images/footer-bird.svg'
import _imports_1 from '../../public/assets/images/background-magnolia.svg'
import _imports_2 from '../../public/assets/images/footer-magnolia.svg'


const _withScopeId = n => (_pushScopeId("data-v-3dfac6f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  style: {"display":"flex","justify-content":"flex-end"}
}
const _hoisted_2 = {
  key: 0,
  class: "footer-image-bird",
  src: _imports_0,
  alt: ""
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "background-magnolia",
  src: _imports_1,
  alt: "",
  style: {"z-index":"-1"}
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "footer-image-magnolia",
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"background-color":"var(--ion-color-footer)","height":"50px"} }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"background-color":"var(--ion-color-tertiary)","height":"50px"} }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.isHome)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (!_ctx.isHome)
            ? (_openBlock(), _createElementBlock("img", _hoisted_2))
            : _createCommentVNode("", true)
        ]))
      : (_ctx.isHome)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_6))
        : _createCommentVNode("", true),
    _hoisted_7,
    _hoisted_8
  ]))
}